<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            <i id="backArrow" @click="openBrands" class="fas fa-chevron-circle-left"></i>{{title}}{{Bname}}
          </h3>
        </div>
        <div class="col text-right">
        </div>
      </div>
    </div>

    <div class="table-responsive">
        <vue-good-table
          :line-numbers="true"
          :columns="columns"
          :rows="data"
          :pagination-options="{
              enabled: true,
              mode: 'pages',
              perPage: 10
              }"
          :search-options="{
            enabled: true,
            placeholder: 'Search this table',
            }"
          >
              <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'action'">
          <router-link :to="{path: '/allProducts/' + props.row.uniqueId}">
              <button type="button" class="btn btn-sm btn-primary btn-circle">
                  <i class="fas fa-eye"></i>
              </button>
          </router-link> 
          <button @click="deleteProduct(props.row.id)" type="button" class="btn btn-danger btn-sm btn-circle">
              <i  class="fas fa-trash"></i>
          </button>
        </span>
        <span v-else>
          {{props.formattedRow[props.column.field]}}
        </span>
      </template>
      
      </vue-good-table>
    </div>

  </div>
</template>
<script>
  export default {
    name: 'productsTable',
    props: {
      type:String,
      title: String,
      Bid: Number,
      Bname: String,
      rows:Array,
    },
    data() {
      return {
        columns: [
        {
          label: 'Name',
          field: 'title',
        },
        {
          label: 'Actions',
          field: 'action',
          
        },
        ],
        data: this.rows
      }
    },
    created(){
    },
    methods:{
      openBrands(){
        this.$emit("openBrand");
      },
      deleteProduct(id){
              this.$swal.fire({
                  title: 'Delete this Product?',
                  text: 'You wont be able to revert this!',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Yes, delete it!',
              }).then((result) => {
                  // send the request to the controller
                  if (result.value) {
                      this.axios.delete("/admin/shopLocal/delete-product/" + id).then(()=>{
                          this.$swal.fire(
                              'Success!',
                              'Product deleted successfully',
                              'success'
                          )
                        this.data = this.data.filter((row)=>{
                          return row.id != id;
                        })
                      });
                  }
              }).catch(()=>{
                  this.$swal("Failed!", "There was something wrong.", "warning");
              })
      }
    }
  }
</script>
<style>
</style>
